import * as service from './service'
export default {
  namespace: 'longPartnerHome',
  state: {
    homeData: {},
    awardData: {},
    shareData: {}
  },
  effects: {
    * getHomeData ({ payload }, { call, put }) {
      const res = yield call(service.getHomeData, payload)
      yield put({
        type: 'save',
        payload: {
          homeData: res.data.data
        }
      })
      return res.data
    },
    * getAwardData ({ payload }, { call, put }) {
      const res = yield call(service.getAwardData, payload)
      yield put({
        type: 'save',
        payload: {
          awardData: res.data.data
        }
      })
      return res.data
    },
    * getShareData ({ payload }, { call, put }) {
      const res = yield call(service.getShareData, payload)
      yield put({
        type: 'save',
        payload: {
          shareData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
